// extracted by mini-css-extract-plugin
export default {"client":"Client_client__UDyAS","logo":"Client_logo__oMAwL","name":"Client_name__5SAdH","number":"Client_number__CLj0g"};